// extracted by mini-css-extract-plugin
export var messageSideLeft = "_q8-1";
export var stateContainer = "_q8-0";